var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-12 space-y-8"},[_c('div',{staticClass:"text-center"},[_c('BaseButton',{attrs:{"tag":"router-link","small":"","primary":"","to":_vm.toPreview,"target":"_blank"}},[_vm._v(" Open in another tab ")])],1),_c('div',{staticClass:"max-w-4xl mx-auto"},[(_vm.accOrder)?_c('Preview',{attrs:{"acc-order":_vm.accOrder}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }